CustomTC.define('modules/stats/stats',['modules/util', 'modules/core', 'modules/config', 'modules/constants', 'modules/options', 'modules/load-data', 'modules/language', 'modules/logger', 'platformjs/platform', 'text!modules/htmls/loading.html', 'text!modules/stats/htmls/debug.html', 'text!modules/stats/htmls/stats.html', 'css!modules/css/loading', 'css!modules/stats/css/stats'], function(util, core, config, constants, options, loadData, language, logger, platform, loading, debug, stats) {
    return {
        statsArray: {},
        taskItemInContext: '',
        clickCoords: '',
        clickCoordsX: '',
        clickCoordsY: '',
        menu: '',
        menuItems: '',
        menuState: 0,
        menuWidth: '',
        menuHeight: '',
        menuPosition: '',
        menuPositionX: '',
        menuPositionY: '',
        windowWidth: '',
        windowHeight: '',
        hlsStatsTimer: '',
        statsInitied: false,

        //init
        init: function(playerUI, player, config) {
            this.playerUI = playerUI;
            this.player = player;
            this.config = config;
            this.initializeStats();
        },
        // initalize stats
        initializeStats: function() {
            var self = this;
            this.video = options.getVideoInfo()[options.getCurrentKey()];
            if (!self.statsInitied) {
                var debugContainer = core.init(debug);
                core.init('body').find('.' + constants.CSS_TOUCHCAST_PLAYER_CONTAINER + '').append(debugContainer);
                var statsContainer = core.init(stats);
                core.init('body').find('.' + constants.CSS_TOUCHCAST_PLAYER_CONTAINER + '').append(statsContainer);

                this.menu = document.querySelector("#" + constants.CSS_TOUCHCAST_CONTEXT_MENU);
                this.menuItems = this.menu.querySelectorAll("." + constants.CSS_TOUCHCAST_CONTEXT_MENU_ITEM);

                this.contextListener();
                this.clickListener();
                this.keyupListener();
                this.resizeListener();
                self.statsInitied = true;
                window.onkeydown = function(e) {
                    if (e.keyCode === 68 && e.ctrlKey) {
                        e.preventDefault();
                        self.showStats();
                    } else if (e.keyCode === 73 && e.ctrlKey) {
                        var temp = core.init("<input>");
                        core.append(core.init("body"), temp);
                        core.setVal(temp, self.getStats());
                        temp.select();
                        document.execCommand("copy");
                        core.remove(temp);
                    }
                }
            }
            var clipboardOption = {
                afterCopy: function(e) {},
                onError: function(e) {
                    var actionMsg;
                    if (/iPhone|iPad/i.test(navigator.userAgent)) {
                        actionMsg = 'No support :(';
                    } else if (/Mac/i.test(navigator.userAgent)) {
                        actionMsg = 'Press ⌘-' + 'C to ' + e.action;
                    } else {
                        actionMsg = 'Press Ctrl-' + 'C to ' + e.action;
                    }
                }
            };
            core.copyClipboard('#' + constants.CSS_TOUCHCAST_CONTEXT_MENU_ITEM_COPY_DEBUG + '', clipboardOption, function(e) {
                return self.getStats();
            });

            self.copyEmbed()

            var statsContainerCloseIcon = core.init('.' + constants.CSS_TOUCHCAST_STATS_CONTAINER_CLOSE + '');
            core.off(statsContainerCloseIcon, 'touchstart click');
            core.on(statsContainerCloseIcon, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                core.html(core.init('.' + constants.CSS_TOUCHCAST_STATS_CONTAINER + ''), '');
                core.hide(core.init('.' + constants.CSS_TOUCHCAST_STATS_MAIN_CONTAINER));
                clearInterval(self.hlsStatsTimer);
                return false;
            });

        },
        copyEmbed: function(){
          var clipboardOption = {
              afterCopy: function(e) {},
              onError: function(e) {
                  var actionMsg;
                  if (/iPhone|iPad/i.test(navigator.userAgent)) {
                      actionMsg = 'No support :(';
                  } else if (/Mac/i.test(navigator.userAgent)) {
                      actionMsg = 'Press ⌘-' + 'C to ' + e.action;
                  } else {
                      actionMsg = 'Press Ctrl-' + 'C to ' + e.action;
                  }
              }
          };
          var embedCode;
          core.copyClipboard('#' + constants.CSS_TOUCHCAST_CONTEXT_MENU_ITEM_COPY_EMBED + '', clipboardOption, function(e) {
              if (options.getTcVideoType() === 'note') {
                  embedCode = "<iframe width='640' height='404' src='//" + options.getDomain() + "/embed/" + options.getVideoInfo()[options.getCurrentKey()].id + "' frameborder='0' allowfullscreen> </iframe>";
              } else {
                  embedCode = "<iframe width='640' height='404' src='//" + options.getDomain() + "/embed/" + options.getVideoInfo()[options.getCurrentKey()].id + "' frameborder='0' allowfullscreen> </iframe>";
              }
              return embedCode;
          });
        },
        // get stats
        getStats: function() {
            var self = this;
            this.video = options.getVideoInfo()[options.getCurrentKey()];
            var v = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '')[0];
            var now = Date.now();
            self.statsArray['playerVersion'] = self.player.getVersion();
            self.statsArray['sdkVersion'] = TouchCast.getSDKVersion();
            self.statsArray['videoID'] = self.video.id;
            if (options.isHls()) {
                self.statsArray['playlistUrl'] = self.player.getHlsSource();
            } else {
                self.statsArray['url'] = self.video.url;
            }
            self.statsArray['date'] = (new Date(now)).toISOString();
            self.statsArray['streamType'] = location.protocol;
            self.statsArray['playerWidth'] = self.player.getVideoAreaWidth();
            self.statsArray['playerHeight'] = self.player.getVideoAreaHeight();
            self.statsArray['playerOffsetX'] = self.player.getVideoAreaX();
            self.statsArray['playerOffsetY'] = self.player.getVideoAreaY();
            self.statsArray['windowWidth'] = core.getWindowWidth();
            self.statsArray['windowHeight'] = core.getWindowHeight();
            self.statsArray['browser'] = platform.name;
            self.statsArray['browserVersion'] = platform.version;
            self.statsArray['os'] = platform.os;
            self.statsArray['userAgent'] = navigator.userAgent;
            self.statsArray['volume'] = options.getVolume() * 10 + '%';
            self.statsArray['curTime'] = self.player.getCurrentTime();
            self.statsArray['playerConfig'] = self.config;
            var videoPlaybackQuality = v.getVideoPlaybackQuality;
            if (videoPlaybackQuality && typeof(videoPlaybackQuality) === typeof(Function)) {
                self.statsArray['droppedVideoFrames'] = v.getVideoPlaybackQuality().droppedVideoFrames;
                self.statsArray['corruptedVideoFrames'] = v.getVideoPlaybackQuality().corruptedVideoFrames;
            } else if (v.webkitDroppedFrameCount) {
                self.statsArray['droppedVideoFrames'] = v.webkitDroppedFrameCount;
            }
            if (options.isHls()) {
                self.statsArray['liveStreamLogs'] = options.getHlsStats();
            }
            return JSON.stringify(self.statsArray);
        },
        // get stats
        showStats: function() {
            var self = this;
            self.hlsStatsTimer = setInterval(function() {
                self.video = options.getVideoInfo()[options.getCurrentKey()];
                var statsHtml = '';
                var v = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '')[0];
                var hlsStats = options.getHlsStats();
                statsHtml += '<div class="tcStatsItem"><div class="tcStatsItemTitle">Video ID:</div><span>' + self.video.id + '</span></div>';
                statsHtml += '<div class="tcStatsItem"><div class="tcStatsItemTitle">Stream Type:</div><span>' + location.protocol + '</span></div>';
                statsHtml += '<div class="tcStatsItem"><div class="tcStatsItemTitle">Player Dimensions:</div><span>' + self.player.getVideoAreaWidth() + ' x ' + self.player.getVideoAreaHeight() + '</span></div>';
                statsHtml += '<div class="tcStatsItem"><div class="tcStatsItemTitle">Player Offsets:</div><span>X:' + self.player.getVideoAreaX() + ' Y:' + self.player.getVideoAreaY() + '</span></div>';
                statsHtml += '<div class="tcStatsItem"><div class="tcStatsItemTitle">Window Dimensions:</div><span>' + core.getWindowWidth() + ' x ' + core.getWindowHeight() + '</span></div>';
                statsHtml += '<div class="tcStatsItem"><div class="tcStatsItemTitle">Volume:</div><span>' + options.getVolume() * 10 + '%</span></div>';
                var videoPlaybackQuality = v.getVideoPlaybackQuality;
                if (videoPlaybackQuality && typeof(videoPlaybackQuality) === typeof(Function)) {
                    statsHtml += '<div class="tcStatsItem"><div class="tcStatsItemTitle">Dropped Frames:</div><span>' + v.getVideoPlaybackQuality().droppedVideoFrames + '</span></div>';
                    statsHtml += '<div class="tcStatsItem"><div class="tcStatsItemTitle">Corrupted Frames:</div><span>' + v.getVideoPlaybackQuality().corruptedVideoFrames + '</span></div>';
                } else if (v.webkitDroppedFrameCount) {
                    statsHtml += '<div class="tcStatsItem"><div class="tcStatsItemTitle">Dropped Frames:</div><span>' + v.webkitDroppedFrameCount + '</span></div>';
                }
                if (options.isHls()) {
                    statsHtml += self.recurseHlsStats(hlsStats);
                }
                core.html(core.init('.' + constants.CSS_TOUCHCAST_STATS_CONTAINER + ''), statsHtml);
            }, 100);
            core.show(core.init('.' + constants.CSS_TOUCHCAST_STATS_MAIN_CONTAINER));

            return;
        },
        // check click inside element
        clickInsideElement: function(e, className) {
            var self = this;
            var el = e.srcElement || e.target;
            if (el.classList.contains(className)) {
                return el;
            } else {
                while (el = el.parentNode) {
                    if (el.classList && el.classList.contains(className)) {
                        return el;
                    }
                }
            }
            return false;
        },
        // get position
        getPosition: function(e) {
            var self = this;
            var posx = 0;
            var posy = 0;

            if (!e) var e = window.event;

            if (e.pageX || e.pageY) {
                posx = e.pageX;
                posy = e.pageY;
            } else if (e.clientX || e.clientY) {
                posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
                posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
            }
            return {
                x: posx,
                y: posy
            }
        },
        // context listner
        contextListener: function() {
            var self = this;
            document.addEventListener("contextmenu", function(e) {
                self.taskItemInContext = self.clickInsideElement(e, constants.CSS_TOUCHCAST_MAIN_CONTAINER);
                if (self.taskItemInContext) {
                    e.preventDefault();
                    self.toggleMenuOn();
                    self.positionMenu(e);
                } else {
                    self.taskItemInContext = null;
                    self.toggleMenuOff();
                }
            });
        },
        // click listner
        clickListener: function() {
            var self = this;
            document.addEventListener("click", function(e) {
                var clickeElIsLink = self.clickInsideElement(e, constants.CSS_TOUCHCAST_CONTEXT_MENU_ITEM_LINK);

                if (clickeElIsLink) {
                    e.preventDefault();
                    self.menuItemListener(clickeElIsLink);
                } else {
                    var button = e.which || e.button;
                    if (button === 1) {
                        self.toggleMenuOff();
                    }
                }
            });
        },
        // key up listner
        keyupListener: function() {
            var self = this;
            window.onkeyup = function(e) {
                if (e.keyCode === 27) {
                    self.toggleMenuOff();
                }
            }
        },
        // resize listner
        resizeListener: function() {
            var self = this;
            window.onresize = function(e) {
                self.toggleMenuOff();
            };
        },
        // toggle context menu on
        toggleMenuOn: function() {
            var self = this;
            if (options.isHls()) {
                core.hide(core.init('#' + constants.CSS_TOUCHCAST_CONTEXT_MENU_ITEM_COPY_EMBED + ''));
                core.setCss(core.init('#' + constants.CSS_TOUCHCAST_CONTEXT_MENU_ITEM_SHOW_DEBUG + '').parent(), {
                    'margin-bottom': '0px'
                });
                core.hide(core.init('.' + constants.CSS_TOUCHCAST_CONTEXT_MENU + ''))
            }
            if (self.menuState !== 1) {
                self.menuState = 1;
                self.menu.classList.add(constants.CSS_TOUCHCAST_CONTEXT_MENU_ACTIVE);
            }
        },
        // toggle context menu off
        toggleMenuOff: function() {
            var self = this;
            if (self.menuState !== 0) {
                self.menuState = 0;
                self.menu.classList.remove(constants.CSS_TOUCHCAST_CONTEXT_MENU_ACTIVE);
            }
        },
        // position context menu
        positionMenu: function(e) {
            var self = this;
            self.clickCoords = self.getPosition(e);
            self.clickCoordsX = self.clickCoords.x;
            self.clickCoordsY = self.clickCoords.y;

            self.menuWidth = self.menu.offsetWidth + 4;
            self.menuHeight = self.menu.offsetHeight + 4;

            self.windowWidth = window.innerWidth;
            self.windowHeight = window.innerHeight;

            if ((self.windowWidth - self.clickCoordsX) < self.menuWidth) {
                self.menu.style.left = self.windowWidth - self.menuWidth + "px";
            } else {
                self.menu.style.left = self.clickCoordsX + "px";
            }

            if ((self.windowHeight - self.clickCoordsY) < self.menuHeight) {
                self.menu.style.top = self.windowHeight - self.menuHeight + "px";
            } else {
                self.menu.style.top = self.clickCoordsY + "px";
            }
        },
        // menu item listner
        menuItemListener: function(link) {
            var self = this;
            var task = self.taskItemInContext.getAttribute("data-id");
            var taskAction = link.getAttribute("data-action");
            self.toggleMenuOff();
            if (taskAction === 'CopyDebug') {
                //self.getStats();
            } else if (taskAction === 'ShowDebug') {
                self.showStats();
            } else if (taskAction === 'CopyEmbed') {
                self.copyEmbed();
            }
        },
        sortObject: function(obj) {
            if (typeof obj !== 'object')
                return obj
            var temp = {};
            var keys = [];
            for (var key in obj)
                keys.push(key);
            keys.sort();
            for (var index in keys)
                temp[keys[index]] = this.sortObject(obj[keys[index]]);
            return temp;
        },
        recurseHlsStats: function(data) {
            var self = this;
            var htmlRetStr = "";
            for (var key in data) {
                if (typeof(data[key]) === 'object' && data[key] !== null) {
                    htmlRetStr += '<div class="tcStatsItem"><div class="tcStatsItemTitle">' + self.camelCaseToWords(key) + ':</div><span>&nbsp;</span></div>';
                    htmlRetStr += self.recurseHlsStats(data[key]);
                } else {

                    var displayWord = self.camelCaseToWords(key);
                    if (displayWord === 'Segment Latency') {
                        displayWord = 'Segment Latency (ms)';
                    } else if (displayWord === 'Segment Bitrate') {
                        displayWord = 'Segment Bitrate (KBps)';
                    } else if (displayWord === 'Segment Processing') {
                        displayWord = 'Segment Processing (ms)';
                    } else if (displayWord === 'Connection Speed') {
                        displayWord = 'Connection Speed (Kbps)';
                    } else if (displayWord === 'Buffer Health') {
                        displayWord = 'Buffer Health (s)';
                    }
                    if (typeof data[key] === 'string' && data[key].length === 0) {
                        htmlRetStr += '<div class="tcStatsItem"><div class="tcStatsItemTitle">' + displayWord + ':</div><span>&nbsp;</span></div>';
                    } else if (data[key] === undefined) {
                        if (displayWord === 'Buffer Stalled Error') {
                            htmlRetStr += '<div class="tcStatsItem"><div class="tcStatsItemTitle">' + displayWord + ':</div><span>0</span></div>';
                        } else if (displayWord === 'Buffer Nudge On Stall') {
                            htmlRetStr += '<div class="tcStatsItem"><div class="tcStatsItemTitle">' + displayWord + ':</div><span>0</span></div>';
                        } else if (displayWord === 'Buffer Seek Over Hole') {
                            htmlRetStr += '<div class="tcStatsItem"><div class="tcStatsItemTitle">' + displayWord + ':</div><span>0</span></div>';
                        } else {
                            htmlRetStr += '<div class="tcStatsItem"><div class="tcStatsItemTitle">' + displayWord + ':</div><span>&nbsp;</span></div>';
                        }
                    } else {
                        htmlRetStr += '<div class="tcStatsItem"><div class="tcStatsItemTitle">' + displayWord + ':</div><span>' + data[key] + '</span></div>';
                    }
                }
            };
            return (htmlRetStr);
        },
        camelCaseToWords: function(str) {
            if (str) {
                var strMatch = str.match(/^[a-z]+|[A-Z][a-z]*/g);
                if (strMatch) {
                    return strMatch.map(function(x) {
                        return x[0].toUpperCase() + x.substr(1).toLowerCase();
                    }).join(' ');
                } else {
                    return str;
                }
            } else {
                return str;
            }
        }

    }

});

